/* @flow */

export default {
  star: {
    stroke: ({ lightTheme, darkAccentColor, accentColor }: Object) =>
      lightTheme ? darkAccentColor : accentColor,
    fill: ({ lightTheme, darkAccentColor, accentColor }: Object) =>
      lightTheme ? darkAccentColor : accentColor,

    cursor: 'pointer',
  },
  favorite: {
    /* Edge fix required so that the event propagation works on the SVG */
    pointerEvents: 'none',
  },
};
